import { getPathList, getMenuPathList, getButtonList, removeMenuList, removePathList, removeMenuPathList, removeButtonList } from './menu'
import { setLoginTime, getLoginTime, removeLoginTime, removeToken, removeUserInfo, getToken } from './token'
import { message } from 'antd';
import Dayjs from 'dayjs'

export const checkMenu = path => {
  const menuPathList = getMenuPathList() || []
  console.log('%c [ menuPathList ]-8', 'font-size:13px; background:pink; color:#bf2c9f;', menuPathList)
  return menuPathList.includes(path)
}

//  检查按钮权限
export const checkButton = type => {
  const buttonList = getButtonList() || []
  return buttonList.includes(type)
}

//  子页面路径
export const getChildPath = path => {
  const pathList = JSON.parse(getPathList()) || {}
  return pathList[path] || []
}

//  验证手机号
export const checkPhone = phone => {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}

//  检查登录
export const checkLogin = () => {
  let loginTime = new Date(getLoginTime()).getTime() || 0
  let token = getToken() || ''
  if(token) {
    if(new Date().getTime() - loginTime > 1000 * 60 * 60 * 8) {
      message.error('登录失效，请重新登录')
      removeLoginTime()
      removeToken()
      removeUserInfo()
      removeMenuList()
      removePathList()
      removeMenuPathList()
      removeButtonList()
      return false
    } else {
      setLoginTime(Dayjs().format('YYYY-MM-DD HH:mm:ss'))
      return true
    }
  } else {
    return true
  }
}